import React from 'react';
import useInView from '../../hooks/useInView';

/**
 * Wraps content in a scroll-triggered reveal.
 *
 * variant:
 *   'rise'  — copy and controls: opacity + a short lift.
 *   'mask'  — display type: wipes up from behind a clipping edge.
 *   'plate' — photography: the frame opens while the image settles from a
 *             slight overscale, so the picture arrives rather than appearing.
 *   'rule'  — hairlines: draws from the leading edge.
 *
 * `index` staggers siblings by 60ms steps without hand-written delays.
 */
export default function Reveal({
  as: Tag = 'div',
  variant = 'rise',
  index = 0,
  className = '',
  style,
  children,
  ...rest
}) {
  const { ref, ready, inView } = useInView();

  return (
    <Tag
      ref={ref}
      data-reveal={variant}
      data-reveal-ready={ready ? 'true' : 'false'}
      data-inview={inView ? 'true' : 'false'}
      className={className}
      style={{ '--reveal-index': index, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
